import { ComponentType } from "react";
import { WidgetComponentProps } from "./types";
import { ActionButtonWidget } from "./widgets/ActionButtonWidget";
import { ExecutionOutputWidget } from "./widgets/ExecutionOutputWidget";
import { LatestNListWidget } from "./widgets/LatestNListWidget";
import { MarkdownWidget } from "./widgets/MarkdownWidget";
import { RecordFormWidget } from "./widgets/RecordFormWidget";
import { RecordListWidget } from "./widgets/RecordListWidget";
import { RelationGraphWidget } from "./widgets/RelationGraphWidget";
import { RunFlowWithInputsWidget } from "./widgets/RunFlowWithInputsWidget";
import { SingleRecordWidget } from "./widgets/SingleRecordWidget";
import { StatTileWidget } from "./widgets/StatTileWidget";
import { StatusStripWidget } from "./widgets/StatusStripWidget";
import { StatusTileWidget } from "./widgets/StatusTileWidget";
import { StatusMatrixWidget } from "./widgets/StatusMatrixWidget";

/**
 * Registry mapping a widget `type` to its renderer component.
 *
 * To add a widget: implement a component taking {@link WidgetComponentProps} and
 * register it here under its config `type` key. Unknown types render a fallback in
 * {@link DashboardWidgetFrame}, so partial coverage degrades gracefully.
 */
export const dashboardWidgetMapper: Record<string, ComponentType<WidgetComponentProps<any>>> = {
    action_button: ActionButtonWidget,
    execution_output: ExecutionOutputWidget,
    latest_n_list: LatestNListWidget,
    markdown: MarkdownWidget,
    record_form: RecordFormWidget,
    record_list: RecordListWidget,
    relation_graph: RelationGraphWidget,
    run_flow_with_inputs: RunFlowWithInputsWidget,
    single_record: SingleRecordWidget,
    stat_tile: StatTileWidget,
    status_strip: StatusStripWidget,
    status_tile: StatusTileWidget,
    status_matrix: StatusMatrixWidget,
    // Backward-compat alias: the widget was originally named `test_status_matrix`
    // (renamed to the generic `status_matrix`). Keep the old key registered so any
    // pre-rename dashboard config still renders.
    test_status_matrix: StatusMatrixWidget,
};
